<template>
  <div class="pageWrap">
    <!-- <voiceBox></voiceBox> -->
    <!-- 图片预览弹框 -->
    <van-image-preview
      v-model="imgPreviewShow"
      :images="previewImgList"
      :showIndex="false"
    ></van-image-preview>
    <!-- 视频弹出框 -->
    <van-popup v-model="videoPreviewShow">
      <div class="prevideoBox">
        <video
          controls="controls"
          autoplay="autoplay"
          :src="previewVideoUrl"
          width="100%"
          height="100%"
        >
        </video>
      </div>
    </van-popup>
    <!-- 进度条遮罩层 -->
    <van-overlay :show="progressShow">
    <div class="colJcAc" style="height: 100%"  @click.stop>
        <div class="progressContent colJcAc"> 
             <div class="progressBox">
            <div class="progressImg">
                <img  src="../../assets/static/progressImg.svg" alt="">
            </div>
            <div style="margin-top: 0.24rem"></div>
             <span class="progress_out">
                <span class="progress_in" :style="{width:fakeUploadPercentage+'%'}"></span>
            </span>
            <div :style="{marginTop: '0.28rem'}" class="progressText fontScN7 fontH2 rowJc">正在上传{{fakeUploadPercentage}}%</div>
        </div>
        </div>
    </div>
    </van-overlay>
    <task-detail :detail="detail"></task-detail>
    <div class="doTaskBox">
      <div class="title">提交作业</div>
      <textarea
        v-model="content"
        class="textarea"
        maxlength="1000"
        placeholder="请输入..."
      ></textarea>
      <div class="textNum">{{ content.length }}/1000</div>
      <div class="fileList flexRow">
        <!-- 视频 -->
        <div
          v-for="(item, index) in previewVideoUrlList"
          :key="'video' + index"
          class="fileItem"
          @click="previewVideo(item)"
        >
          <video
            class="videoBox"
            preload="auto"
            id="upvideo"
            :controls="false"
            :show-center-play-btn="false"
            :src="item.url"
            :poster="item.imgsrc"
          >
            <!-- <source :src="item.url" type="video/mp4" />
            <source :src="item.url" type="video/ogg" />
            <source :src="item.url" type="video/webm" /> -->
          </video>
          <img
            src="../../assets/static/task/play-circle.png"
            class="playCircle"
            alt=""
          />
          <div class="closeBox" @click.stop="clearFile('video', index)">
            <img
              src="../../assets/static/task/circle-close.svg"
              alt=""
              class="closeImg"
            />
          </div>
        </div>
        <!-- 图片 -->
        <div
          v-for="(item1, index1) in imgList"
          :key="'img' + index1"
          class="fileItem"
          @click="previewImg(index1)"
        >
          <van-image width="100%" height="100%" fit="cover" :src="item1.url" />
          <div class="closeBox" @click.stop="clearFile('image', index1)">
            <img
              src="../../assets/static/task/circle-close.svg"
              alt=""
              class="closeImg"
            />
          </div>
        </div>
        <!-- 音频 -->
        <div
          v-for="(item2, index2) in voiceList"
          :key="index2"
          class="fileItem voiceItem rowJcAc"
          @click="playVoice(item2)"
        >
          <img
            src="../../assets/static/task/musicIcon.svg"
            alt=""
            class="musicIcon"
          />
          <!-- <audio controls="controls" :src="item.url" width="100%"></audio> -->
          <div class="closeBox" @click.stop="clearFile('voice', index2)">
            <img
              src="../../assets/static/task/circle-close.svg"
              alt=""
              class="closeImg"
            />
          </div>
        </div>
      </div>
      <!-- <div class="fileList flexRow">
                <div v-for="(item2,index2) in voiceList" :key="'voice'+index2" class="voiceItem">
                    <audio controls="controls" :src="item2.url"></audio>
                    <div class="closeBox" @click="clearFile('voice',index2)">
                        <img src="../../assets/static/task/circle-close.svg" alt="" class="closeImg">
                    </div>
                </div>
            </div> -->
      <div class="rowJb addFileBox">
        <!-- <div class="addBox">
          <div class="icon-video" @click="addFile('video')"></div>
          <input
            type="file"
            ref="videoInput"
            accept="video/*"
            class="addInput"
            @change="submitFile($event, 'video')"
            v-if="previewVideoUrlList.length < 3"
          />
        </div> -->
        <div class="addBox">
          <div class="icon-camera" @click="addFile('img')"></div>
          <input
            type="file"
            accept="image/*"
            ref="imgInput"
            class="addInput"
            @change="submitFile($event, 'image')"
            v-if="imgList.length < 3"
          />
        </div>
        <!-- <div class="addBox">
          <div class="icon-voice" @click="addFile('voice')"></div>
          <input type="file" class="addInput" accept="audio/*" @change="submitFile($event,'voice')">
          <input
            type="file"
            class="addInput"
            ref="voiceInput"
            @change="submitFile($event, 'voice')"
            v-if="voiceList.length < 3"
          />
        </div> -->
      </div>
    </div>
    <div
      class="bottomBtn"
      :class="[hasContent && submitIsClick ? 'ableBtn bgcMcA1' : 'disableBtn']"
      @click="submitTask"
    >
      提交作业
    </div>
  </div>
</template>
<script>
import TaskDetail from "../../components/task/taskDetail.vue";
import { baseURL } from '../../utils/request'
import {common} from '../../utils/common.js'
import {
  putDetailAPI,
  postTaskUploadFile,
  checkFileAPI,
  uploadFileAPI,
  mergeFileAPI,
} from "../../utils/api/taskApi";
import sparkMD5 from "spark-md5";
const CHUNK_SIZE = 4 * 1024 * 1024; //切片尺寸
// import voiceBox from '../../components/task/voice'
export default {
  name: "submitTask",
  data() {
    return {
      content: "",
      imgList: [], // 图片列表
      videoList: [], // 视频列表
      voiceList: [], // 录音列表
      previewImgList: [], // 预览图片
      previewVideoUrl: "", // 预览视频路径
      videoPreviewShow: false, // 预览视频是否展示
      imgPreviewShow: false,
      taskId: "", // 作业id
      campusCode: "", // 机构code
      parentUid: "", //
      detail: {}, // 某作业详情
      workType: 1, //类型 1：提交 3：更新
      submited: true, // 是否可提交，防重复提交
      isNoticeJump: false, // 是否从通知点进去
      submitIsClick: true,
      fileSuffix: "", //上传视频时的文件后缀名
      chunksList: 0, //chunk长度
      file: null, //文件
      institutionCode: "", //校区code
      uploadedList: [], //未上传的切片数组，即要上传的切片
      chunks: [], //存放切片
      previewVideoUrlList: [], //本地视频上传时预览
      imgsrc: "", //展示当前视频预览截图第一帧
      urlVideo: null,
      fakeUploadPercentage: 0,  //设置进度条
      chunks: [],
      worker: null,
      progressShow: false,
      uploadFlag: null,  //检查是否上传标志
    };
  },
  computed: {
    hasContent() {
      return (
        this.content ||
        this.imgList.length != 0 ||
        this.previewVideoUrlList.length != 0 ||
        this.voiceList.length != 0
      );
    },
    uploadPercentage() {
      if ((!this.file) || !this.chunks.length) {
        return 0;
      }
      if(this.uploadFlag === true) {
          return 100
      }
      const loaded = this.chunks
        .map((item) => item.size * item.percentage)
        .reduce((acc, cur) => acc + cur);
        console.log('如果计算', parseInt(((loaded) / this.file.size).toFixed(2)))
        console.log('JNONJHUIOJNIO', this.chunks)
      return parseInt(( loaded / this.file.size).toFixed(2));
    },
  },
  components: { TaskDetail },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/jumpTask") {
        // 若从修改作业页面进来，悬浮弹框关闭
        vm.isNoticeJump = true;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    // 若进入的是音频页，则缓存当前页
    if (to.path == "/voice") {
      // from.meta.keepAlive = true
    } else {
      this.$bus.$emit("pageEvent", { pageName: "submitTask", type: "del" });
      // from.meta.keepAlive = false
    }
    next();
  },
  created() {
    console.log("test", this.$route.params);
    this.$bus.$emit("pageEvent", { pageName: "submitTask", type: "add" });
    this.detail = this.$route.params.taskInfo;
    if (this.$route.params.parentUid) {
      this.parentUid = this.$route.params.parentUid;
    }
    if (this.$route.params.alterData) {
      var alterData = this.$route.params.alterData.homeworkData;
      this.content = alterData.content;
      this.workType = 3;
      if (alterData.imgList) {
        alterData.imgList.forEach((item) => {
          this.imgList.push({ url: item, type: "image" });
        });
      }
      if (alterData.videoList) {
        alterData.videoList.forEach((item) => {
          this.videoList.push({ url: item, type: "video" });
        });
      }
      if (alterData.voiceList) {
        alterData.voiceList.forEach((item) => {
          this.voiceList.push({ url: item, type: "voice" });
        });
      }
    }
    if (this.$route.params.workType == 4) {
      this.workType = 4;
    }
    this.getCampusInfo();
  },
  watch: {
    uploadPercentage(now) {
        console.log('now-------', now)
      if (now != 100 && now > this.fakeUploadPercentage) {
        this.fakeUploadPercentage = now;
      } else if(now == 100) {
          this.fakeUploadPercentage = now
      }
      console.log('看是否能得到进度条', this.fakeUploadPercentage, typeof this.fakeUploadPercentage)
    }
  },
  mounted() {
    this.taskId = this.$route.params.taskInfo.id;
  },
  methods: {
    //截取视频第一帧作为播放前默认图片
    getVideoBase64(url) {
            let dataURL = '';
            let video = document.createElement("video");
            video.setAttribute('crossOrigin', 'anonymous');//处理跨域
            video.setAttribute('src', url);
            video.setAttribute('width', 400);
            video.setAttribute('height', 240);
            video.currentTime = 200; //截取第200帧
            video.addEventListener('loadeddata', function () {
                let canvas = document.createElement("canvas");
                let width = video.width; //canvas的尺寸和图片一样
                let height = video.height;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
                dataURL = canvas.toDataURL('image/jpeg'); //转换为base64
                this.imgUrl = dataURL;
                console.log(this.imgUrl);
            });
        },
    // 预览视频
    previewVideo(item) {
      this.previewVideoUrl = item.url;
      this.videoPreviewShow = true;
      console.log("点击预览视频的链接------", item.url);
    },
    // 点击播放音频
    playVoice(item) {
      this.$router.push({ name: "Voice", params: { url: item.url } });
    },
    // 获取校区信息
    getCampusInfo() {
      this.institutionCode = JSON.parse(
        this.$common.getCache("customerAuthList")
      )[0].institutionCode; //获取校区code
      console.log("获取校区code", this.institutionCode);
      if (this.$common.getCache("campusItem")) {
        // 判断本地有无校区信息
        var campusItem = JSON.parse(this.$common.getCache("campusItem"));
        this.parentUid = campusItem.customerId;
        this.campusCode = campusItem.campusCode;
      } else {
        var campusList = JSON.parse(this.$common.getCache("customerAuthList"));
        if (campusList) {
          this.campusCode = campusList[0].campusCode;
          this.parentUid = campusList[0].customerId;
        }
      }
    },
    submitFile(event, type) {
        console.log('上传文件', event, type)
        if (type == "video") {
        this.chunks = [];
        this.progressShow = true;
        this.file = event.target.files[0];
        this.urlVideo = URL.createObjectURL(this.file);
        console.log("000000000000000--0", this.urlVideo);
        var length = event.target.files[0].name.split(".").length;
        this.fileSuffix = event.target.files[0].name.split(".")[length - 1];
        let fileList = event.target.files;
        let fileData = fileList[0];
        this.$refs.videoInput.value = "";
        if (this.videoList.length == 3) {
        this.$toast("最多只能上传3个视频");
        return;
        }
        if (fileData.size > 1024 * 1024 * 1024) {
        this.$toast("上传视频不能超过1G");
        return;
        }
        this.uploadFile();

        console.log("查看本地预览视频路径", this.videoList);
        
      } else {
        var formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("application", 'xk-wx')
        formData.append("type", 2) // 1.系统文件 2.应用文件
        let fileList = event.target.files;
        let fileData = fileList[0];
        if (type == "image") {
          this.$refs.imgInput.value = "";

          if (this.imgList.length == 3) {
            this.$toast("最多只能上传3张图片");
            return;
          }
          if (fileData.size > 1024 * 1024 * 10) {
            // 不能超过2M
            this.$toast("上传图片不能超过10M");
            return;
          }
          postTaskUploadFile(formData).then((res) => {
            if (res.resultCode == 200) {
              this.imgList.push({ url: res.data, type: type });
            } else {
              this.$toast(res.resultStr);
            }
          });
        } else if (type == "voice") {
          this.$refs.voiceInput.value = "";
          if (this.voiceList.length == 3) {
            this.$toast("最多只能上传3个音频");
            return;
          }
          if (fileData.type.search("audio/") == -1) {
            this.$toast("请上传正确的音频格式");
            return;
          }
          if (fileData.size > 1024 * 1024 * 20) {
            this.$toast("上传音频不能超过20M");
            return;
          }
          postTaskUploadFile(formData).then((res) => {
            if (res.resultCode == 200) {
              this.voiceList.push({ url: res.data, type: type });
            } else {
              this.$toast(res.resultStr);
            }
          });
          // this.voiceList.push({url: fileSrc,type: type})
        }
      }
      // window.URL 有兼容问题
      // // 兼容代码
      // const windowURL = window.URL || window.webkitURL;
      // // window.URL.createObjectURL 会根据传入的参数创建一个指向该参数对象的URL
      // let fileSrc = windowURL.createObjectURL(fileData);
     
    },
    // 删除某个文件
    clearFile(type, index) {
      if (type == "image") {
        this.imgList.splice(index, 1);
      } else if (type == "video") {
        this.previewVideoUrlList.splice(index, 1);
        this.videoList.splice(index, 1);
      } else if (type == "voice") {
        this.voiceList.splice(index, 1);
      }
    },
    // 点击添加文件
    addFile(type) {
      if (type == "img" && this.imgList.length >= 3) {
        this.$toast("最多只能上传3张图片");
      }
      if (type == "video" && this.videoList.length >= 3) {
        this.$toast("最多只能上传3个视频");
      }
      if (type == "voice" && this.voiceList.length >= 3) {
        this.$toast("最多只能上传3个音频");
      }
    },
    // 点击提交作业
    submitTask() {
      if (this.hasContent && this.submited && this.submitIsClick) {
        this.submited = false;
        var videoUrl = "";
        var imageUrl = "";
        var voiceUrl = "";
        this.imgList.forEach((item, index) => {
          imageUrl += index == 0 ? item.url : "," + item.url;
        });
        this.videoList.forEach((item, index) => {
          videoUrl += index == 0 ? item.url : "," + item.url;
        });
        this.voiceList.forEach((item, index) => {
          voiceUrl += index == 0 ? item.url : "," + item.url;
        });
        var obj = {
          id: this.taskId,
          workType: this.workType, //类型 1->提交  2->删除  3->更新 4->再次提交
          content: this.content,
          videoUrl: videoUrl,
          imageUrl: imageUrl,
          voiceUrl: voiceUrl,
        };
        // 之前为单条数据时使用作业详情id,现在多条数据要使用每条作业的id
        if (this.$route.params.alterData) {
          obj.id = this.$route.params.alterData.id;
        }
        console.log("提交作业的obj", obj);
        putDetailAPI(obj).then((res) => {
          this.submited = true;
          console.log("提交作业返回结果：", res);
          if (res.resultCode == 200) {
            this.$toast("提交成功");
            if (this.isNoticeJump) {
              this.submitIsClick = false;
              this.$router.replace({
                name: "TaskDetail",
                params: { taskInfo: this.detail, parentUid: this.parentUid },
              });
            } else {
              this.$router.back(-1);
            }

            // this.$router.replace({path: '/taskList'})
          } else {
            this.$toast(res.resultStr);
          }
        });
      }
    },
    // 预览图片
    previewImg(index) {
      this.previewImgList = [this.imgList[index].url];
      this.imgPreviewShow = true;
    },
    //创建文件切片
    createFileChunk(file, size = CHUNK_SIZE) {
      const chunks = [];
      let cur = 0;
      let index = 0;
      console.log("文件切片的尺寸", file.size, file);
      while (cur < file.size) {
        chunks.push({
          index: index,
          file: file.slice(cur, cur + size),
        });
        cur += size;
        index += 1;
      }
      console.log("chunks------", chunks);
      return chunks;
    },
    //单独封装进度条请求
    request({
      url,
      method = "post",
      data,
      headers = {},
      onProgress = e => e,
      requestList
    }) {
        return new Promise(resolve => {
            const xhr = new XMLHttpRequest()
            xhr.upload.onprogress = onProgress
            xhr.open(method, url)
            Object.keys(headers).forEach(key => {
                xhr.setRequestHeader(key, headers[key])
            })
            xhr.send(data)
            xhr.onload = e => {
                if(requestList) {
                    const xhrIndex = requestList.findIndex(item => item === xhr)
                    requestList.splice(xhrIndex, 1)
                }
                resolve({
                    data: e.target.response
                })
            }
            requestList?.push(xhr)
        })
    },
    //计算hash
    async calculateHash(fileChunkList) {
      return new Promise(resolve => {
        this.worker = new Worker("/hash.js");
        this.worker.postMessage({ fileChunkList });
        this.worker.onmessage = e => {
          const { percentage, hash } = e.data;
          this.hashPercentage = percentage;
          if (hash) {
            resolve(hash);
          }
        };
      });
    },
    //上传文件--判断当前选择文件有没有上传过
    async uploadFile() {
      this.uploadFlag = null
      this.uploadedList = [];
      if (!this.file) {
        return;
      }
      const chunks = this.createFileChunk(this.file);
      
      const hash = await this.calculateHash(chunks);
      console.log("md5-----", hash);
      this.hash = hash;
      //请求后端是否上传过文件，如果没有是否有存在的切片
      const obj = {
        md5: this.hash,
      };
      await checkFileAPI(obj).then((res) => {
        if (res.resultCode == 200) {
          //已经上传过，秒传
          console.log('已经上传过，秒传成功')
          this.fakeUploadPercentage = 100
          this.videoList.push({ url: res.data, type: "video" });
          this.previewVideoUrlList.push({
            url: URL.createObjectURL(this.file),
            imgsrc: this.getVideoBase64(URL.createObjectURL(this.file)),
            type: "video",
          });
          this.uploadFlag = true
          this.progressShow = false
          this.fakeUploadPercentage = 0 
        } else if (res.resultCode == "40004026") {
          //切片上传不完整，断点续传
          res.data.forEach((item) => {
            this.uploadedList.push(item.toString());
          });
        //   this.$toast("上传失败，请重新上传！");
        } else if (res.resultCode == "404") {
          //文件没有上传过，直接上传切片
          chunks.forEach((item) => {
            this.uploadedList.push(item.index.toString());
          });
        } else if (res.resultCode == "201") {
          //切片已经上传完成,可以直接请求合并
           this.mergeFile();
        }
      });
      console.log('jopijoifdjoudfh', this.uploadedList)
      //当文件没有完全上传时重新上传或者上传文件
      this.chunks = chunks.map((chunk, index) => {
        console.log('打印现在的hash:', this.hash)
        return {
          hash,
          name: this.hash + '-' + index,
          index: chunk.index,
          chunk: chunk.file,
          size: chunk.file.size,
          //设置上传进度条
          percentage: this.uploadedList.includes(index) ? 100 : 0,
        };
      });
      console.log('小查看map玩的', this.chunks)
      this.chunksList = this.chunks.length;
      console.log('打印现在的上传判断看是否正确', !this.uploadFlag || this.uploadedList.length != 0, this.uploadFlag, this.uploadedList.length)
      if(!this.uploadFlag || this.uploadedList.length != 0) {
          await this.uploadChunks(this.uploadedList);
      }
    },
    //上传切片并计算每个切片的上传进度
    async uploadChunks(uploadedList = []) {
      const requests = this.chunks
        .filter(({name}) => !uploadedList.includes(name))
        .map((chunk, index) => {
          const form = new FormData();
          form.append("chunkCnt", this.chunksList);
          form.append("currChunk", chunk.index);
          form.append("chunkSize", CHUNK_SIZE);
          form.append("size", CHUNK_SIZE);
          form.append("fileSuffix", "." + this.fileSuffix);
          form.append("md5", this.hash);
          form.append("file", chunk.chunk);
          return { form, index };
        })
        .map( async ({ form, index }) => {
          console.log("form", form);
          await this.request({
              url: baseURL + '/crm/wx/parent/file/sharding/upload',
              data: form,
              onProgress: this.createProgressHandler(this.chunks[index]),
              requestList: requests,
              headers: {'Authorization': common.getCache('token')}
          })
        });
      await Promise.all(requests);
      console.log('resqyests', )
      if (requests.length == 0) {
          this.progressShow = false
          this.fakeUploadPercentage = 0 
        //此时promise数组为空，即没有上传切片
      } else {
        await this.mergeFile();
      }
    },
    //用闭包保存每个chunk的进度数据
    createProgressHandler(item) {
        return e => {
            item.percentage = parseInt(String((e.loaded / e.total) * 100))
        }
    },
    //上传切片完成后请求合并切片
    async mergeFile() {
      const obj = {
        md5: this.hash,
        fileSuffix: "." + this.fileSuffix,
        type: 9,
        campusCode: this.campusCode,
        institutionCode: this.institutionCode,
        fileSize: this.file.size,
      };
      console.log("合并切片传参----", obj);
      await mergeFileAPI(obj).then((res) => {
        if (res.resultCode == 200) {
          // this.findvideocover(this.urlVideo, this.file)
            this.previewVideoUrlList.push({
              url: this.urlVideo,
              type: "video",
              imgsrc: this.getVideoBase64(this.urlVideo)
            });
          console.log("添加后的预览视频------", this.previewVideoUrlList);
          this.videoList.push({ url: res.data, type: "video" });
          this.progressShow = false
          this.fakeUploadPercentage = 0
        } else {
          this.progressShow = false
          this.fakeUploadPercentage = 0
          this.$toast(res.resultStr);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// 音频
// audio {
//   width: 100%;
//   height: 40px;
//   outline: none;
//   filter: invert(180); //c3 filter(滤镜) 属性
// }

// audio::-webkit-media-controls-enclosure {
//   background: rgb(129, 73, 200);
//   /* 滤镜反转为 rgba(0, 162, 255, 1);rgba(255, 93, 0, 0.8)  #7eb637   10,10,10  #757575 */
//   border-radius: 4px;
// }
// .media-controls-container,
// .media-controls-container * {
//   background: rgb(129, 73, 200);
//   //滤镜反转为 rgba(0, 162, 255, 1);rgba(255, 93, 0, 0.8)  #7eb637
//   border-radius: 4px;
// }
// audio::-webkit-media-controls-play-button {
//   height: 22px;
//   width: 22px;
//   min-width: 22px;
//   border-radius: 50%;
//   flex-basis: 22px;
// }

// // 音量隐藏
// audio::-webkit-media-controls-volume-control-container {
//   display: none;
// }

// audio::-webkit-media-controls-current-time-display {
//   order: 1; //设置弹性盒对象元素的顺序
//   color: #000;
//   text-shadow: unset;
// }

// audio::-webkit-media-controls-time-remaining-display {
//   order: 2;
//   color: rgba(0, 0, 0, 0.6);
//   text-shadow: unset;
// }
/deep/ {
  .van-popup {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    width: 100%;
    height: 50%;
  }
}
.prevideoBox {
  width: 100%;
  height: 100%;
}
.pageWrap {
  position: relative;
  width: 100%;
  min-height: 100%;
  overflow: auto;
  padding: 0.12rem 0.12rem 1rem;
  box-sizing: border-box;
  background: linear-gradient(180deg, #89c4ff 0%, #f5f6f9 20%);
}
.playCircle {
  width: 0.32rem;
  height: 0.32rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -0.16rem;
  margin-left: -0.16rem;
}
.musicIcon {
  width: 0.26rem;
  height: 0.28rem;
}
.doTaskBox {
  margin-top: 0.12rem;
  background: #ffffff;
  border-radius: 0.12rem;
  padding: 0.12rem 0.16rem 0.28rem;
  box-sizing: border-box;
}
.title {
  font-size: 0.16rem;
  line-height: 0.24rem;
  font-weight: 500;
  margin-bottom: 0.12rem;
}
.textarea {
  width: 100%;
  line-height: 0.22rem;
  min-height: 1.32rem;
  font-size: 0.14rem;
  color: #5a6073;
  border: none;
}
.textNum {
  font-size: 0.12rem;
  color: #9ea5bb;
  text-align: right;
  line-height: 0.18rem;
  margin-top: 0.04rem;
}
.addFileBox {
  padding: 0.2rem 0.2rem 0;
  font-size: 0.32rem;
  color: #9ea5bb;
}
.addBox {
  width: 0.32rem;
  height: 0.32rem;
  position: relative;
}
.addInput {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.fileList {
  flex-wrap: wrap;
  width: calc(100% + 0.1rem);
}
.videoBox {
  width: 0.72rem;
  height: 0.72rem;
}
.fileItem {
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 0.04rem;
  overflow: hidden;
  position: relative;
  margin-top: 0.2rem;
  margin-right: 0.1rem;
  border: 1px solid #e8ebf3;
}
.voiceItem {
  position: relative;
  background: #36cfc9;
}
.closeBox {
  z-index: 2;
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 2px;
  .closeImg {
    width: 0.16rem;
    height: 0.16rem;
  }
}
.bottomBtn {
  position: absolute;
  bottom: 0.12rem;
  left: 0.12rem;
  width: calc(100% - 0.24rem);
  height: 0.44rem;
  border-radius: 0.12rem;
  line-height: 0.44rem;
  text-align: center;
  font-size: 0.16rem;
}
.ableBtn {
  color: #fff;
}
.disableBtn {
  color: #9ea5bb;
  background: #e8ebf3;
}
.progressBox {
    border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
    width: 1.83rem;
}
.progressImg {
    // margin-top: 0.32rem;
    text-align: center;
    img {
        width: 1rem;
        height: 1rem;
    }
}
.progressLine {
    margin-top: 0.24rem;
    margin-left: 0.32rem;
    margin-right: 0.32rem;
    width: 1.83rem;
}
/deep/.van-overlay {
    z-index: 100;
}
.progressContent {
    width: 2.47rem;
    height: 2.52rem;
    background: #FFFFFF;
    border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
    }
    .progress_out{
    display:inline-block;
    width: 1.83rem;
    height: 0.08rem;
    border-radius: 0.09rem;
    background-color: #E8EBF3;
    position:relative;
    top:0;
    left:0;
    margin-right:10px;
    .progress_in{
        display:inline-block;
        height:0.08rem;
        border-radius: 2px;
        background: linear-gradient(135deg, #44C2FF 0%, #1A7AF8 100%);
        border-radius: 0.09rem;
        background-position:center right;
        position:absolute;
        top:0;
        left:0;
    }
}
</style>